import { selectChangeMessageForThemes } from '@UI/aside/asideThemes/AsideThemesSelectors';
import { type ContentHref, ContentType } from '@generalTypes/apiTypes';
import type { EditAsideThemes } from '@nodeTypeConfig/configTypes';
import { contentTypesKey } from '@store/constants/constants';

export const proContentTypeForDatabasePicker: EditAsideThemes = {
  component: 'databaseTypes',
  property: 'themes',
  reactComponent: 'AsideThemes',
  label: 'Databanktype',
  options: {
    referenceFrameHref: `/content/${contentTypesKey}` as ContentHref,
    types: [ContentType.THEME],
  },
  asideChangeMessageSelector: selectChangeMessageForThemes,
};
